// Modal Content, This content is mainly used for Modal with MainModal.tsx Component
import React, { useState } from "react";
import social from "../assets/icons/insta.svg";
import user from "../assets/images/user.png";
import SearchBar from "./SearchBar";
import { FaPlus } from "react-icons/fa6";
import { FaPlay } from "react-icons/fa";
import rCheck from "../assets/icons/radio_button_check.svg"
import nonCheck from "../assets/icons/RadioNonCheckedIcon.svg"
import Button from "./Button";
import { TranslateIcon } from "../assets/icons/Icons";

export const Voice = () => {
  const [check, setCheck] = useState(false);
  return (
    <div onClick={() => setCheck(!check)} className="flex items-center cursor-pointer justify-between px-3 py-2 rounded-xl bg-white mb-2">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full text-white bg-[#2A2A36] flex items-center justify-center">
          <FaPlay className="text-xs" />
        </div>
        <div>
          <p className="text-[#0F0C18] text-base font-medium tracking-tight">Andrew’s voice 1</p>
          <div className="flex items-center gap-1">
            <img src={user} className="w-3 h-3 rounded-full" alt="user" />
            <p className="text-[#9392A2] text-xs font-medium tracking-tight">My male voice • Deep voice</p>
          </div>
        </div>
      </div>
      {
        check ? 
          <img onClick={() => setCheck(false)} className="cursor-pointer w-4 h-4" src={rCheck} alt="radio" /> :
          <img onClick={() => setCheck(true)} className="cursor-pointer w-4 h-4" src={nonCheck} alt="radio" /> 
          
      }
    </div>
  );
};

const SelectVoice = () => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-normal">Choose a voice you want to use in this <br /> particular account and language.</p>
      <SearchBar className="bg-white mt-3" inputCss="text-xs" />
      <p className="text-[#9392A2] text-xs mt-4 mb-3 font-medium tracking-tight">For account</p>
      <div className="flex items-center justify-between px-3 py-2 rounded-xl bg-white">
        <div className="flex items-center gap-3">
          <div className="relative w-10 h-10 rounded-full">
            <img className="w-full h-full" src={user} alt="user" />
            <img className="w-4 h-4 rounded-full absolute right-0 bottom-0" src={social} alt="social" />
          </div>
          <div className="text-[#0F0C18] text-base font-medium tracking-tight">@martin_frazer</div>
        </div>
        <div className="flex items-center gap-1">
          <TranslateIcon />
          <p className="text-[#9392A2] text-xs mt-4 mb-3 font-medium tracking-tight">English</p>
        </div>
      </div>
      <p className="text-[#9392A2] text-xs mt-5 mb-3 font-medium tracking-tight">My voices</p>
      <div className="px-3 py-2 rounded-xl bg-white mb-2">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 border border-[#9392A2] border-dashed rounded-full">
            <FaPlus />
          </div>
          <div className="text-[#9392A2] text-base font-medium tracking-tight">Add your voice</div>
        </div>
      </div>
      <Voice />
      <p className="text-[#9392A2] text-xs mt-5 mb-3 font-medium tracking-tight">System voices</p>
      <Voice />
      <Button label="Confirm" className="mt-4" />
    </>
  );
};

export default SelectVoice;